import api from "@/api/reports";

// initial state
const state = {
  orderReports: [],
  bestSellingProducts: [],
  bestSellingCategories: []
};

// getters
const getters = {
  orderReports: state => {
    return state.orderReports;
  },
  bestSellingProducts: state => {
    return state.bestSellingProducts;
  }
};
// actions
const actions = {
  getOrderReports: async (context, parameter) => {
    let d = (await api.getOrderReports(parameter)).data;
    context.commit("getOrderReports", d);
    return d;
  },
  getHasAverage: async (context, parameter) => {
    let d = (await api.getHasAverage(parameter)).data;
    context.commit("getHasAverage", d);
    return d;
  },
  getBestSellingProductsReports: async (context, parameter) => {
    let d = (await api.getBestSellingProductsReports(parameter)).data;
    context.commit("getBestSellingProductsReports", d);
    return d;
  },
  getBestSellingCategoriesReports: async (context, parameter) => {
    let d = (await api.getBestSellingCategoriesReports(parameter)).data;
    context.commit("getBestSellingCategoriesReports", d);
    return d;
  }
};

// mutations
const mutations = {
  getOrderReports(state, products) {
    state.orderReports = products;
  },
  getHasAverage(state, average) {
    state.hasAverage = average;
  },
  getBestSellingProductsReports(state, product) {
    state.bestSellingProducts = product;
  },
  getBestSellingCategoriesReports(state, product) {
    state.bestSellingCategories = product;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
